<template>
  <div>
    <top-message />
    <div class="bottomPart">
      <div>
        <div class="titlePart">用户清单</div>
        <el-form
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
          style="padding: 20px 30px 0"
        >
          <el-form-item label="业务权限">
            <el-select
              v-model="searchForm.bankAuth"
              placeholder="请选择"
              style="width: 200px"
              @change="handleChange1"
              clearable
            >
              <el-option
                v-for="item in authOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="searchForm.isStop"
              placeholder="请选择"
              style="width: 200px"
              @change="handleChange2"
              clearable
            >
              <el-option
                v-for="item in statusOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <div style="padding: 0">
          <el-table
            :data="tableData"
            style="width: 100%;"
          >
            <el-table-column
              prop="deptName"
              label="所属机构"
              width="200"
              align="center"
            />
            <el-table-column
              prop="name"
              label="姓名"
              align="center"
            />
            <el-table-column
              prop="cpValue"
              label="信易贷业务权限"
              align="center"
            >
              <template slot-scope="scope">
                <img
                  v-if="scope.row.cpValue !==  0"
                  src="../../assets/images/hasAuth.png"
                  alt
                />
                <img
                  v-else
                  src="../../assets/images/notAuth.png"
                  alt
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="sbValue"
              label="机构业务上报权限"
              align="center"
            >
              <template slot-scope="scope">
                <img
                  v-if="scope.row.sbValue !== 0"
                  src="../../assets/images/hasAuth.png"
                  alt
                />
                <img
                  v-else
                  src="../../assets/images/notAuth.png"
                  alt
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="isStop"
              label="状态"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{scope.row.isStop==0?'启用':'停用'}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="200"
              align="center"
              prop="isStop"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleUpdate(scope.row)"
                  v-if="scope.row.isStop == '1'"
                ><span style="color: #35BD6A">启用</span></el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="handleUpdate(scope.row)"
                  v-if="scope.row.isStop == '0'"
                ><span style="color: #F85B4B">停用</span></el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="handleSetting(scope.row)"
                >权限设置</el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="handleShow(scope.row)"
                >查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-dialog
          :visible.sync="showVisible"
          width="30%"
          :show-close="false"
          custom-class="dialog1"
          :modal-append-to-body="false"
          :lock-scroll="false"
        >
          <div class="bodyPart">
            <div class="bodyTitle">用户详情</div>
            <div class="bodyContent">
              <div class="bodyItem">
                <div class="label">用户姓名：</div>
                <div class="value">{{detailInfo.name}}</div>
              </div>
              <div class="bodyItem">
                <div class="label">机构名称：</div>
                <div class="value">{{detailInfo.deptName}}</div>
              </div>
              <div class="bodyItem">
                <div class="label">联系电话：</div>
                <div class="value">{{detailInfo.mobilePhone}}</div>
              </div>
              <div class="bodyItem">
                <div class="label">统一社会信用代码：</div>
                <div class="value">{{detailInfo.deptId}}</div>
              </div>
            </div>
            <el-button
              type="primary"
              class="myPrimaryButton"
              @click="handleSubmit"
            >确认</el-button>
          </div>
        </el-dialog>
        <el-dialog
          :visible.sync="updateVisible"
          width="400px"
          :show-close="false"
          custom-class="dialog2"
          :modal-append-to-body="false"
          :lock-scroll="false"
        >
          <div class="bodyPart">
            <div class="bodyContent">
              <img
                v-if="detailInfo.isStop == 1"
                src="../../assets/images/openUse.png"
                alt
              />
              <img
                v-else
                src="../../assets/images/notUse.png"
                alt
              />
            </div>
            <div class="bodyTitle">
              {{ detailInfo.isStop == 1 ? '启用' : '停用' }}该角色</div>
            <div>
              <el-button
                class="myPrimaryButton"
                @click="handleCancel"
              >取消</el-button>
              <el-button
                type="primary"
                class="myPrimaryButton"
                @click="handleUpdateSubmit"
              >确认</el-button>
            </div>
          </div>
        </el-dialog>
        <el-dialog
          :visible.sync="settingVisible"
          width="400px"
          :show-close="false"
          custom-class="dialog3"
          :modal-append-to-body="false"
          :lock-scroll="false"
        >
          <div class="bodyPart">
            <div class="bodyTitle">权限设置</div>
            <div class="bodyContent">
              <el-switch
                v-model="cpShow"
                active-text="信易贷业务权限"
                active-color="#2981EE"
                inactive-color="#909090"
                @change="handleSwitchChange1($event)"
              />
              <el-switch
                v-model="sbShow"
                active-text="机构业务上报权限"
                active-color="#2981EE"
                inactive-color="#909090"
                @change="handleSwitchChange2($event)"
              />
            </div>
            <div>
              <el-button
                class="myPrimaryButton"
                @click="handleCancel"
              >取消</el-button>
              <el-button
                type="primary"
                class="myPrimaryButton"
                @click="handleSettingSubmit"
              >确认</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import TopMessage from "@/components/TopMessage";
import { queryAuth, List, operateexport } from "../../api/review";

export default {
  components: { TopMessage },
  data () {
    return {
      searchForm: {
        isStop: '',
        bankAuth: '',
      },
      authOption: [
        { label: "信易贷业务", value: "3" },
        { label: "机构业务上报", value: "2" },
      ],
      statusOption: [
        { label: "启用", value: "0" },
        { label: "停用", value: "1" },
      ],
      tableData: [
        // { organization: "工商银行-总行", name: "张三", auth1: false, auth2: true, status: 1 },
        // { organization: "工商银行-总行", name: "李四", auth1: true, auth2: false, status: 0 },
      ],
      showVisible: false,
      updateVisible: false,
      settingVisible: false,
      detailInfo: "",
      sbShow: false,
      cpShow: false,
      cpVal: 0,
      sbVal: 0
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      List(this.sendParam(this.searchForm)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code == 200) {
          this.tableData = res.data;
        }

      }).catch(err => {

      })
    },
    // getList () {
    //   queryAuth(this.searchForm).then(res => {
    //     this.tableData = res.data.data;
    //   });
    // },
    handleUpdate (row) {
      this.detailInfo = row;
      this.updateVisible = true;
    },
    handleSetting (row) {
      this.detailInfo = row;
      this.settingVisible = true;
      if (row.cpValue !== 0) {
        this.cpShow = true;
        this.cpVal = 1
      } else {
        this.cpShow = false;
      }

      if (row.sbValue !== 0) {
        this.sbShow = true;
        this.sbVal = 1
      } else {
        this.sbShow = false;
      }
    },
    handleShow (row) {
      this.detailInfo = row;
      this.showVisible = true;
    },
    handleSubmit () {
      this.showVisible = false;
    },
    handleCancel () {
      this.updateVisible = false;
      this.settingVisible = false;
    },
    // 调用接口
    handleUpdateSubmit () {
      let Stop = ''
      if (this.detailInfo.isStop == 0) {
        Stop = 1
      } else if (this.detailInfo.isStop == 1) {
        Stop = 0
      }
      let data = {
        loginName: this.detailInfo.loginName,
        sbValue: '',
        cpValue: '',
        isStop: Stop,
        operaType: 2
      }
      operateexport(this.sendParam(data)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {

      })
      this.updateVisible = false;
    },
    // 调用接口
    handleSettingSubmit () {
      let data = {
        loginName: this.detailInfo.loginName,
        sbValue: this.sbVal,
        cpValue: this.cpVal,
        isStop: '',
        operaType: 1
      }
      operateexport(this.sendParam(data)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {

      })
      this.settingVisible = false;
    },
    // 改变值
    handleSwitchChange1 (val) {
      if (val) {
        this.cpVal = 1
      } else {
        this.cpVal = 0
      }
    },
    handleSwitchChange2 (val) {
      if (val) {
        this.sbVal = 1
      } else {
        this.sbVal = 0
      }
    },
    // 改变值
    handleChange1 (val) {
      this.searchForm.bankAuth = val
      this.getList();
    },
    handleChange2 (val) {
      this.searchForm.isStop = val
      this.getList();
    },
    statusFormat (row) {
      return row.isStop == 0 ? "启用" : "停用";
    }
  }
}
</script>

<style lang="less" scoped>
.bottomPart {
  width: 100%;
  min-height: 740px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px 0;
  font-size: 14px;
  border-radius: 6px;
  margin-top: 20px;
  .titlePart {
    color: #2981ee;
    font-size: 24px;
    font-weight: bold;
    border-left: 6px solid #2981ee;
    padding-left: 20px;
  }
  .el-divider {
    background-color: #f3f4f9;
  }
}
/deep/.el-table {
  thead tr th {
    background: #f3f4f9;
  }
}
/deep/.dialog1 {
  border-radius: 10px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 20px;
    .bodyPart {
      display: flex;
      flex-direction: column;
      align-items: center;
      .bodyTitle {
        font-size: 22px;
        color: #2a2a2a;
        font-weight: 550;
      }
      .bodyContent {
        padding: 30px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        .bodyItem {
          width: 200px;
          margin-bottom: 20px;
          padding: 0 10px;
          .label {
            background: #e7eef6;
            color: black;
            font-weight: 550;
            font-size: 16px;
            margin-bottom: 4px;
            padding-left: 8px;
          }
          .value {
            padding-left: 8px;
          }
        }
      }
    }
  }
}
/deep/.dialog2 {
  border-radius: 10px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 20px;
    .bodyPart {
      display: flex;
      flex-direction: column;
      align-items: center;
      .bodyContent {
        img {
          width: 46px;
          height: 46px;
          margin-bottom: 20px;
        }
      }
      .bodyTitle {
        font-size: 26px;
        color: black;
        margin-bottom: 35px;
      }
    }
  }
}
/deep/.dialog3 {
  border-radius: 10px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 20px;
    .bodyPart {
      display: flex;
      flex-direction: column;
      align-items: center;
      .bodyContent {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        .el-switch {
          margin: 10px 0;
        }
      }
      .bodyTitle {
        font-size: 26px;
        color: black;
        margin-bottom: 35px;
      }
    }
  }
}
</style>
